import updateFolder from './updateFolder';
import FolderInfoResponseMessage from 'owa-service/lib/contract/FolderInfoResponseMessage';
import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import setFolderField from 'owa-service/lib/factory/setFolderField';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import folder from 'owa-service/lib/factory/folder';

export default function(
    folderId: string | DistinguishedFolderIdName,
    newDisplayName: string
): Promise<FolderInfoResponseMessage> {
    return updateFolder(folderId, [
        setFolderField({
            Path: propertyUri({
                FieldURI: 'FolderDisplayName',
            }),
            Folder: folder({
                DisplayName: newDisplayName,
            }),
        }),
    ]);
}
